import React from 'react'
import { shuffle, take } from 'lodash'

import { useCoverQuery } from '../../types/generated'

import Covers from './Covers'

export default function CoverContainer() {
  const { data: coverData, loading: isCoverLoading } = useCoverQuery()

  const getCoverItems = () => {
    if (!coverData?.cover.nodes) {
      return []
    }

    const { cover } = coverData
    const coverItems = cover.sortBy === 'random' ? shuffle(cover.nodes) : cover.nodes

    return take(coverItems, 3)
  }

  return <Covers nowLoading={isCoverLoading} coverItems={getCoverItems()} />
}
